import zxcvbn from "zxcvbn";
export function passwordStrengthRule() {
    return function (input) {
        // zxcvbnのscoreを、フロントエンド > サーバーサイド にしている
        // see: https://git.pepabo.com/colorme/sanma/pull/291#issuecomment-2468794
        return zxcvbn(input).score >= 3 ||
            "パスワードの強度が十分ではありません。大文字・小文字・数字・記号を組み合わせて、より複雑なパスワードを入力してください。";
    };
}
//# sourceMappingURL=password-strength.js.map